import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

export const customizeDateHandling = (): void => {
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
};
